export default function GiftBoxIcon({ className = 'w-14 h-14' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 48 48"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Gift card"
    >
      {/* Box body */}
      <rect x="10" y="20" width="28" height="20" rx="2" fill="white" fillOpacity="0.25" />
      {/* Vertical ribbon */}
      <rect x="22" y="20" width="4" height="20" fill="white" fillOpacity="0.5" />
      {/* Lid */}
      <g className="animate-gift-lid">
        <rect x="8" y="16" width="32" height="6" rx="2" fill="white" fillOpacity="0.4" />
        {/* Bow */}
        <path
          d="M24 16c-2-3-6-4-8-1s1 5 3 4c-2 1-5 3-3 6s6 1 8-2c2 3 6 4 8 1s-1-5-3-4c2-1 5-3 3-6s-6-1-8 2z"
          fill="white"
          fillOpacity="0.6"
        />
        <circle cx="24" cy="16" r="2" fill="white" fillOpacity="0.8" />
      </g>
    </svg>
  );
}
